import { render, staticRenderFns } from "./register-data.vue?vue&type=template&id=e55b5ff8&scoped=true"
import script from "./register-data.vue?vue&type=script&lang=js"
export * from "./register-data.vue?vue&type=script&lang=js"
import style0 from "./register-data.vue?vue&type=style&index=0&id=e55b5ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55b5ff8",
  null
  
)

export default component.exports